<template>
  <v-col class="text-center px-2 py-2" md="3" cols="6">
    <nuxt-link
      :ref="`catItem`"
      :to="`/jobs/subcat/${subCategory.id}/`"
      class="black--text display-18 no-underline area-item "
    ><span class="cat-list-item">{{subCategory.name}}</span></nuxt-link>
  </v-col>
</template>

<script>


export default {
  components: {  },

  props: {
    subCategory: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data() {
    return {
      showMoreSubCats: false
    }
  },

  created() {},

  mounted() {},

  computed: {},
  methods: {
    catIcon(code) {
      switch (code) {
        case 30:
          return 'icon-security'
        case 28:
          return 'icon-internet'
        case 24:
          return 'icon-browser'
        case 4:
          return 'icon-cpu'
        case 5:
          return 'icon-monitor'
        case 6:
          return 'icon-coding'
        default:
          return 'icon-monitor'
      }
    },
    showMore() {
      this.showMoreSubCats = !this.showMoreSubCats
    }
  }
}
</script>

<style lang="scss" scoped>
.area-item {
  background-color: $light-gray;
  width: 100%;
  display: flex;
  text-align: center;
  padding: 10px 0;
  justify-content: center;
}

</style>